import { ButtonCoreDriver } from '../Button/ButtonCore/ButtonCore.uni.driver';

export interface TextButtonUniDriver extends ButtonCoreDriver {}
